import React, { useState } from "react";
import PropTypes from 'prop-types';
function Tooltip({ className, children }) {
    const [tooltipStatus, setTooltipStatus] = useState(0);

    return (
        <div className={`${className}`}>
            <div className=" flex-col md:flex-row flex items-center md:justify-center ">
                {/*Code Block for white tooltip starts*/}
                <button type="button" className="mt-0 md:mt-0" onMouseEnter={() => setTooltipStatus(1)} onMouseLeave={() => setTooltipStatus(0)} onFocus={() => setTooltipStatus(1)} onBlur={() => setTooltipStatus(0)}>
                    <div className="mr-2 cursor-pointer">
                        <svg className="w-4 h-4 fill-current text-gray-300 rotate-180" viewBox="0 0 16 16">
                            <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z" />
                        </svg>
                    </div>
                    {tooltipStatus === 1 && (
                        <div role="tooltip" className="z-20 -mt-0 w-64 absolute transition duration-150 ease-in-out left-0 ml-0 shadow-lg bg-white p-4 rounded border">
                            {/* <svg className="absolute left-0 -ml-2 bottom-0 top-0 h-full" width="9px" height="16px" viewBox="0 0 9 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                <g id="Page-1" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
                                    <g id="Tooltips-" transform="translate(-874.000000, -1029.000000)" fill="#FFFFFF">
                                        <g id="Group-3-Copy-16" transform="translate(850.000000, 975.000000)">
                                            <g id="Group-2" transform="translate(24.000000, 0.000000)">
                                                <polygon id="Triangle" transform="translate(4.500000, 62.000000) rotate(-90.000000) translate(-4.500000, -62.000000) " points="4.5 57.5 12.5 66.5 -3.5 66.5" />
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg> */}
                            {children}
                        </div>
                    )}
                </button>

            </div>
        </div>
    );
}
Tooltip.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Tooltip;

